import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles, IconButton, Modal,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';

import CloseIcon from '@material-ui/icons/CloseRounded';
import * as EventActions from '@services/events/event.action';
import { EditEventStyle } from './EditEvent.style';
import EditEvent from './EditEvent';
import { DialogTop } from '@components/economy/DialogComponens';
import { IAnalysedEvent, IAnalysedImage, IEvent } from '@app-types/websocket/event.types';
import ReactMarkdown from 'react-markdown';
import EventOverlapWarning from './EventOverlapWarning';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  events:IAnalysedEvent[];
  overlapsByEvent:{[id:string]:IEvent[]};
  hidden:string[];
  sent:string[];
  analysis:number[],
  markdown:string[],
  hiddenMarkdown:number[], // indexes of the markdown cards the user has closed
}

interface IProps extends WithStyles<typeof EditEventStyle> {
  close:() => void;
  open:boolean;
  analyzedFiles: IAnalysedImage[];
  dismissAnalyzedImage : (id:number) => void;
  rateApp : () => void;
}

class AiCreateEvents extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);


    this.state = {
      overlapsByEvent:{},
      analysis:[],
      events:[],
      hidden:[],
      sent:[],
      markdown:[],
      hiddenMarkdown:[],
    };
  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    if (this.props.open !== prevProps.open) {
      if (this.props.open) {
        const readyData = this.createEvents(this.props.analyzedFiles);
        this.setState({events:readyData.events, hidden:[], sent:[], analysis:readyData.analysis, 
          markdown:readyData.markdown, hiddenMarkdown:[], overlapsByEvent:{}});
        if (readyData.events.length === 0 && readyData.markdown.length === 0) {
          for (const ai of readyData.analysis) { // nothing to show, but still handled
            this.props.dismissAnalyzedImage(ai);
          }
          this.props.close();
        }
      } else {
        this.setState({events:[], hidden:[], sent:[], analysis:[], markdown:[], hiddenMarkdown:[], overlapsByEvent:{}})
      }
    }
  }

  public render() {

    const icon:JSX.Element = <div />;
    const title:string = "";

    return (
      <Modal open={this.props.open} onClose={() => this.props.close()}>
        <div className={this.props.classes.aIEvents}>
          <div style={{scrollSnapStop: 'always', scrollSnapAlign: 'start'}}/>
          {this.state.markdown.map((markdown, index) =>
            <div key={"makdown"+index} className={this.props.classes.aIEvent 
              + (this.state.markdown.length - this.state.hiddenMarkdown.length === 1 
                && !this.state.hiddenMarkdown.includes(index)
                && ((this.state.hidden.length + this.state.sent.length) === this.state.events.length )?(" "+this.props.classes.onlyEvent):"")
              + (this.state.hiddenMarkdown.includes(index)?(" "+this.props.classes.eventSent):"")}>
              <DialogTop className={this.props.classes.aIMarkdownHeader}>
                <div className={this.props.classes.dialogTitle} style={{textAlign:'center'}}>{title}</div>
                <IconButton onClick={() => this.hideMarkdown(index)}>
                  <CloseIcon />
                </IconButton>
              </DialogTop>
              <div style={{margin:'0px 12px'}}>
                <ReactMarkdown source={markdown} />
              </div>
            </div>
          
          )}
          {this.state.events.map((event) =>
            <div key={event.id} className={this.props.classes.aIEvent 
              + ((this.state.markdown.length === this.state.hiddenMarkdown.length 
                && this.state.hidden.length + this.state.sent.length === this.state.events.length - 1)?(" "+this.props.classes.onlyEvent):"")
              + (this.state.hidden.includes(event.id)?(" "+this.props.classes.eventDeleted):"")
              + (this.state.sent.includes(event.id)?(" "+this.props.classes.eventSent):"")}>
              <DialogTop>
                <div className={this.props.classes.dialogTitle} style={{textAlign:'center'}}>{tn.lang.calNewEvent}</div>
                <IconButton onClick={() => this.hide(event.id)}>
                  <CloseIcon />
                </IconButton>
              </DialogTop>
              <div style={{position:'relative', overflow: 'hidden', display: 'flex', flexDirection: 'column'}}>
                <div style={{position:'relative', display:'flex', flex:1, minHeight:0}}>
                  <EditEvent
                    close={(result) => {
                      if (result==="CREATED") {
                        this.send(event.id);
                      }else {
                        this.hide(event.id);
                      }}}
                    event={undefined}
                    onDate={undefined}
                    analysedEvent={event}
                    onOverlapsChange={(overlaps) => this.setState((state) => ({
                      overlapsByEvent: {...state.overlapsByEvent, [event.id]: overlaps},
                    }))}
                  />
                </div>
                <EventOverlapWarning overlaps={this.state.overlapsByEvent[event.id] || []} />
              </div>
            </div>
          
          )}
        </div>
      </Modal>
    );
  }

  private hideMarkdown(index:number) {
    const hiddenMarkdown = this.state.hiddenMarkdown.slice();
    if (!hiddenMarkdown.includes(index)) {
      hiddenMarkdown.push(index);
    }
    this.setState({hiddenMarkdown});

    this.closeWhenNothingLeft(this.state.hidden, this.state.sent, hiddenMarkdown, true);
  }

  private hide(id:string) {
    const hidden = this.state.hidden.slice();
    if (!hidden.includes(id)) {
      hidden.push(id);
    }
    this.setState({hidden});

    this.closeWhenNothingLeft(hidden, this.state.sent, this.state.hiddenMarkdown, true);
  }

  private send(id:string) {
    const sent = this.state.sent.slice();
    if (!sent.includes(id)) {
      sent.push(id);
    }
    this.setState({sent});

    this.closeWhenNothingLeft(this.state.hidden, sent, this.state.hiddenMarkdown, false);
  }

  private closeWhenNothingLeft(hidden:string[], sent:string[], hiddenMarkdown:number[], askForRating:boolean) {
    if ((hidden.length + sent.length) !== this.state.events.length
      || hiddenMarkdown.length !== this.state.markdown.length) {
      return;
    }

    for (const ai of this.state.analysis) {
      this.props.dismissAnalyzedImage(ai);
    }
    if (askForRating && sent.length > 0) {
      this.props.rateApp();
    }
    setTimeout(() => this.props.close(), 1000);
  }

  private createEvents(analyzedFiles: IAnalysedImage[])
    :{events:IAnalysedEvent[], analysis:number[], markdown:string[]} {
    const newEvents:IAnalysedEvent[] = [];
    const analysis:number[] = [];
    const markdown:string[] = [];

    let index = 0;
    for ( const file of analyzedFiles) {
      if (!file.dismissed && file.events) {
        analysis.push(file.id);
        for (const event of file.events) {
          event.id = file.id+"-"+index;
          index++;
          newEvents.push(event);
        }
      }
      if (!file.dismissed && file.markdown !== undefined && file.markdown.length > 0) {
        // console.log("Markdown", JSON.stringify(file));
        if (!analysis.includes(file.id)) {
          analysis.push(file.id);
        }
        markdown.push(file.markdown);
      }
    }

    return {events:newEvents, analysis, markdown};
  }

}

function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  return {
    userId,
    analyzedFiles:state.event.eventAnalyses?state.event.eventAnalyses:[],
  };
}

const mapDispatchToProps = {
  dismissAnalyzedImage : EventActions.dismissAnalyzedImage,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(EditEventStyle)(AiCreateEvents));



// WEBPACK FOOTER //
// ./src/components/calendar2/eventdetails/AiCreateEvents.tsx